"use client";
import { ReactNode } from "react";
import { FeatureFlagComponentResolverClient } from "@/lib/feature-flags/FeatureFlagResolverClient";
import useIsMobile from "@/hooks/useIsMobile";

import { HubVariants } from "./types";

type StickyNavHubPageProps = {
  hubType?: HubVariants;
  desktop?: ReactNode;
  mobile?: ReactNode;
  legacy?: ReactNode;
};

const StickyNavRedesign = ({
  desktop,
  mobile,
}: Pick<StickyNavHubPageProps, "desktop" | "mobile">) => {
  const isMobile = useIsMobile(1024);
  return isMobile ? mobile : desktop;
};

export const StickyNavHubPage = (props: StickyNavHubPageProps) => {
  return (
    <FeatureFlagComponentResolverClient
      flagKey="NEXT_PUBLIC_FEATURE_DEGREE_HUB_REDESIGN"
      variants={{
        control: (
          <StickyNavRedesign desktop={props.desktop} mobile={props.mobile} />
        ),
        legacy: <>{props.legacy}</>,
      }}
      fallback="control"
    />
  );
};
